import { useOnboardingRouteTracker } from "../helpers/useOnboardingChecklist";

/**
 * Invisible component that tracks route changes for the onboarding checklist.
 * Must live in GlobalContextProviders so it stays mounted across all navigation.
 */
export function OnboardingRouteTracker() {
  useOnboardingRouteTracker();
  return null;
}
